import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import clsx from 'clsx';
import { ContactMainConfirmForm } from '@/components/modules/pages/contact/main/confirm/ContactMainConfirmForm/ContactMainConfirmForm';
import { ContentContainer } from '@/components/ui/Layout/ContentContainer';
import { Head } from '@/components/ui/Typography/Heading/Head';
/**
 * カジュアル相談 View
 * @param props
 * @returns
 */
export const ContactMainConfirmView = (props) => {
    const { className = '', initialValues, onSubmit, prevTo, types } = props;
    return (_jsxs(ContentContainer, Object.assign({ className: clsx('mx-auto', className) }, { children: [_jsx(Head, Object.assign({ className: 'flex justify-center text-left', size: 'lg' }, { children: "\u4E0B\u8A18\u306E\u5185\u5BB9\u3067\u9001\u4FE1\u3057\u307E\u3059" })), _jsx(ContactMainConfirmForm, { className: 'mt-12', initialValues: initialValues, onSubmit: onSubmit, prevTo: prevTo, types: types })] })));
};
